import { Button, List, Tag } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { convertDateToFromNow } from "../../../../../utils/dayjs";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../../../store/chats/slice";
import { useCases } from "../../../../../hooks/useCases";
import { useState } from "react";

const RecentConversation = ({ item, onCancel }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const { cases, loading } = useCases({
    chatId: item?.id,
    fetch: open,
  });

  return (
    <div className="recent-conversation">
      <div className="flex justify-space-between align-center header">
        <div className="ellipsis-text">
          <h4 style={{ fontWeight: "500" }} className="ellipsis-text">
            #{item.display_id}&nbsp;{" "}
            {item?.name ? item?.name : `📍 ${item.branch.name}`}
            <Tag color={"blue"} style={{ marginLeft: "10px" }}>
              {item?.topic?.name}
            </Tag>
          </h4>
          <div className="time ellipsis-text">
            {item?.name ? (
              <span style={{ marginRight: "10px" }}>📍 {item.branch.name}</span>
            ) : (
              ""
            )}
            {convertDateToFromNow(
              item?.last_message?.sent_at || item?.created_at,
            )}
          </div>
        </div>
        <div className="right-div flex align-center">
          <Button
            color="primary"
            variant="dashed"
            size="small"
            onClick={() => {
              dispatch(
                setKeyValue({
                  key: "selectedChatId",
                  value: item?.id,
                }),
              );
              onCancel();
            }}
            disabled={loading}
          >
            Open
          </Button>
          <Button
            type="text"
            className="collapse-icon"
            icon={open ? <UpOutlined /> : <DownOutlined />}
            onClick={() => setOpen(!open)}
            disabled={loading}
            size="small"
          />
        </div>
      </div>
      {open && (
        <List
          loading={loading}
          dataSource={cases}
          renderItem={(c, i) => (
            <List.Item
              key={i}
              className="flex justify-space-between align-center"
              onClick={() => {
                dispatch(
                  setKeyValue({
                    key: "selectedChatId",
                    value: item?.id,
                  }),
                );

                dispatch(
                  setKeyValue({
                    key: "selectedCaseForm",
                    value: c,
                  }),
                );
                onCancel();
              }}
            >
              <div className="case-title">{c?.case_type}</div>
              <div className="time"> {convertDateToFromNow(c?.created_at)}</div>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default RecentConversation;
